export enum NbrbAuthStatus {
    Error = -1,
    GuestFirstVisit = 1001,
}


// WEBPACK FOOTER //
// ./common/enums/nbrbAuthStatus.ts